import { render, staticRenderFns } from "./SpecimenAge.vue?vue&type=template&id=7514b706"
import script from "./SpecimenAge.vue?vue&type=script&lang=js"
export * from "./SpecimenAge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports